import { AuthService } from '@/app/core/services/auth/auth.service';
import { PermissionService } from '@/app/core/services/permission/permission.service';
import { UserProfile, UsersService } from '@/app/core/services/users/users.service';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnDestroy, OnInit {
  private authService = inject(AuthService);
  private permissionService = inject(PermissionService);
  private usersService = inject(UsersService);
  private elementRef = inject(ElementRef);
  private cdr = inject(ChangeDetectorRef);
  private readonly destroy$ = new Subject<void>();

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.menuOpen = false;
      // Notifications: close only via bell toggle (not outside click / hover).
    }
  }

  menuOpen = false;
  notificationsOpen = false;
  notificationsLoading = false;
  user: UserProfile | null = null;

  unreadCount = 0;

  currentPage = 1;
  hasMore = true;
  isLoadingMore = false;
  autoRefreshTimer: ReturnType<typeof setTimeout> | undefined;

  @Input() isCollapsed = false;
  @Input() isMobileOpen = false;

  @Output() sidebarToggle = new EventEmitter<void>();

  ngOnInit() {
    this.loadProfile();
    // Only fetch the unread count initially.
    // The full notification list API will be called when the user clicks the icon.
  }

  ngOnDestroy(): void {
    if (this.autoRefreshTimer) {
      clearTimeout(this.autoRefreshTimer);
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadProfile() {
    this.usersService.getProfile().subscribe({
      next: (res) => {
        this.user = res;
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Profile load failed', err);
      },
    });
  }

  get avatarLetter(): string {
    return this.user?.first_name ? this.user.first_name.charAt(0).toUpperCase() : '';
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
    if (this.menuOpen) {
      this.notificationsOpen = false;
    }
    this.cdr.detectChanges();
  }

  get isMobile(): boolean {
    return window.innerWidth < 768;
  }

  toggleSidebar() {
    this.sidebarToggle.emit();
  }

  logout(event: Event) {
    event.stopPropagation();
    this.authService.logout();
    this.permissionService.clear();
  }
}
